import { z } from 'zod';

export const FREIGHT_TYPE_SCHEMA = z.enum([
    'CONCRETE',
    'ASPHALT',
    'BULK_MATERIAL',
    'RECYCLING_BULK_MATERIAL',
    'CONSTRUCTION_MATERIAL',
    'RECYCLING_CONSTRUCTION_MATERIAL',
    'NON_HAZARDOUS_WASTE',
    'HAZARDOUS_WASTE',
]);

export type FREIGHT_TYPE = z.infer<typeof FREIGHT_TYPE_SCHEMA>;

export const WASTE_FREIGHT_TYPE_SCHEMA = FREIGHT_TYPE_SCHEMA.extract(['NON_HAZARDOUS_WASTE', 'HAZARDOUS_WASTE']);
